import React from "react";

export function ErrorPage403() {
	return (
		<div className="text-center py-5">
			<h1 className="display-1 kt-font-bold">403</h1>
			<h4 className="kt-font-bold">Você não tem permissão para acessar esta página.</h4>
			<p className="kt-font-lg">Solicite ao administrador da sua empresa o acesso a este recurso.</p>
		</div>
	);
}
